module.exports = __webpack_public_path__ + "assets/img/5_1262_big.e91ed141.jpg";